module.exports = __webpack_public_path__ + "static/1Home1-28009da6579fc00bf10e350e7ec9f827.gif";